import { Spinner } from "@components/atoms/Spinner"
import { ComponentProps } from "react"
import { twMerge } from "tailwind-merge"
import { tv } from "tailwind-variants"

type Props = ComponentProps<"div">

const createStyles = tv({
  slots: {
    base: "py-10 flex items-center justify-center gap-4 flex-col animate-fadeIn",
  },
})

export function LoadingResults(props: Props) {
  const styles = createStyles()
  return (
    <div {...props} className={twMerge(styles.base(), props.className)}>
      <Spinner />
    </div>
  )
}
